import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable()
export class ScreenSizeService {
    private innerWidth = window.innerWidth;
    private isMobileSubject = new BehaviorSubject<boolean>(
        this.innerWidth <= 576
    );

    isMobile$ = this.isMobileSubject.asObservable();

    constructor() {
        window.addEventListener("resize", () => {
            this.innerWidth = document.documentElement.clientWidth;
            this.isMobileSubject.next(this.innerWidth <= 576);
        });
    }

    get isMobile(): boolean {
        return this.innerWidth <= 576;
    }
}



// WEBPACK FOOTER //
// C:/Repositories/wfa3/SupplierPortal/app/src/app/shared/services/screen-size.service.ts